import React, { RefObject } from 'react';
import { Spin } from 'antd';
import InfiniteScroll from 'react-infinite-scroller';

import HistoryCard from './HistoryCard';
import { HistoryResponseModel } from 'api/adminApiClient';
import { ActivitiesSectionPageTypeEnum } from 'components/ActivitiesDetailsSection/enums';

import styles from './HistoryList.module.less';

type Props = {
  hasMore: boolean;
  entityId: string;
  historyData: HistoryResponseModel[];
  scrollRef: RefObject<HTMLElement>;
  onLoadMore: (page: number) => void;
  pageType: ActivitiesSectionPageTypeEnum;
};

export default React.memo((props: Props) => {
  const { historyData, onLoadMore, hasMore, scrollRef, pageType, entityId } =
    props;

  return (
    <InfiniteScroll
      pageStart={-1}
      loadMore={onLoadMore}
      hasMore={hasMore}
      loader={<Spin key={0} />}
      useWindow={false}
      getScrollParent={() => scrollRef.current}
      className={styles.historyList}
    >
      {historyData.map((historyItem, index) => (
        <React.Fragment key={`${historyItem.id}-${index}`}>
          <HistoryCard
            pageType={pageType}
            entityId={entityId}
            historyItem={historyItem}
          />
        </React.Fragment>
      ))}
    </InfiniteScroll>
  );
});
